import { Navigate } from 'react-router-dom';
import { usePermissions } from '@/hooks/usePermissions';
import type { Permission } from '@realvisor/shared';

interface PermissionRouteProps {
  permission: Permission;
  children: React.ReactNode;
}

/**
 * Route guard that checks if the current user has a required permission.
 * Redirects cc_operator to campaigns, others to dashboard.
 */
export default function PermissionRoute({ permission, children }: PermissionRouteProps) {
  const { can, role } = usePermissions();

  if (!can(permission)) {
    const fallback = role === 'cc_operator' ? '/callcenter/campaigns' : '/';
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
}
